import { createCustomEvent } from "../../shared/helpers";

const notificationChannel = (function() {
  const connection = App.Cable.connection()

  const init = () => {
    connection.subscriptions.create({channel: "Notifications::NotificationChannel"}, {
      disconnected() {
        emitUpdateEvent({ count: "!", connected: false });
      },

      received({ count }) {
        emitUpdateEvent({ count });
      }
    });
  };

  const emitUpdateEvent = ({ count, connected = true }) => document.dispatchEvent(createCustomEvent("notifications-updated", document, { count, connected }));

  return {
    init: init
  };
})();

export default notificationChannel;



// WEBPACK FOOTER //
// ./app/javascript/channels/notifications/notification_channel.js